import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-testid": "add-simulation-page",
  class: "page add-simulation-page"
}
const _hoisted_2 = { class: "flex w-100" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    onSubmit: _withModifiers(_ctx.addSimulation, ["prevent"]),
                    class: "py-5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between my-4" }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createElementVNode("span", { class: "text-h5" }, " Add Simulation ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            "hide-details": "",
                            color: "accent",
                            "persistent-hint": false,
                            label: `Is SoS(Simulation of simulations): ${_ctx.simulationObject.isSos ? 'Yes' : 'No'}`,
                            modelValue: _ctx.simulationObject.isSos,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.simulationObject.isSos) = $event)),
                            class: "mb-5"
                          }, null, 8, ["label", "modelValue"]),
                          _createVNode(_component_v_divider, { class: "mb-6" }),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("Max number of users", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            placeholder: "Number of contributors in each simulation",
                            modelValue: _ctx.simulationObject.maxUsers,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.simulationObject.maxUsers) = $event)),
                            variant: "underlined",
                            type: "number",
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("Start Date (YYYY-MM-DD)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            placeholder: "Start Date",
                            variant: "underlined",
                            modelValue: _ctx.simulationObject.startDate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.simulationObject.startDate) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createTextVNode("Start Date Type", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_select, {
                            "hide-details": "",
                            items: ['month', 'year'],
                            "persistent-hint": false,
                            variant: "underlined",
                            modelValue: _ctx.simulationObject.startDateType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.simulationObject.startDateType) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("End Date (YYYY-MM-DD)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            placeholder: "End Date",
                            variant: "underlined",
                            modelValue: _ctx.simulationObject.endDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.simulationObject.endDate) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_switch, {
                            "hide-details": "",
                            color: "accent",
                            "persistent-hint": false,
                            label: `Fixed Amount Contributions: ${_ctx.simulationObject.fixedAmounts.toString()}`,
                            modelValue: _ctx.simulationObject.fixedAmounts,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.simulationObject.fixedAmounts) = $event)),
                            class: "mb-5"
                          }, null, 8, ["label", "modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                              _createTextVNode("Max Contribution Amount", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            placeholder: "End Year",
                            type: "number",
                            variant: "underlined",
                            modelValue: _ctx.simulationObject.maxAmount,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.simulationObject.maxAmount) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_switch, {
                            "hide-details": "",
                            color: "accent",
                            "persistent-hint": false,
                            label: `Fixed Number of Contributions: ${_ctx.simulationObject.fixedContributions.toString()}`,
                            modelValue: _ctx.simulationObject.fixedContributions,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.simulationObject.fixedContributions) = $event)),
                            class: "mb-5"
                          }, null, 8, ["label", "modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("Number of contributions/ Max number of contributions(if not fixed)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            variant: "underlined",
                            placeholder: "Number of contributions/ Max number of contributions(if not fixed)",
                            type: "number",
                            modelValue: _ctx.simulationObject.maxContributions,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.simulationObject.maxContributions) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          (_ctx.simulationObject.isSos)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_v_label, null, {
                                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                    _createTextVNode("Number of simulations per contribution number", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_v_text_field, {
                                  "hide-details": "",
                                  "persistent-hint": false,
                                  variant: "underlined",
                                  placeholder: "Number of simulations per contribution number",
                                  type: "number",
                                  modelValue: _ctx.simulationObject.simulationsPerContribution,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.simulationObject.simulationsPerContribution) = $event)),
                                  class: "mb-5"
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            "data-testid": "SubmitUploadBtn",
                            color: _ctx.addingSimulation ? 'disabled' : 'success',
                            type: "submit",
                            loading: _ctx.addingSimulation,
                            disabled: _ctx.addingSimulation
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode("Add", -1)
                            ]))]),
                            _: 1
                          }, 8, ["color", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}